module.exports = __webpack_public_path__ + "img/mailbox.d70667cc.svg";